/* eslint-disable */
const hostname = window && window.location && window.location.origin;
const basePath = "/firm_api";
var domain = `${hostname}${basePath}/v1/user`;
var staffdomain = `${hostname}${basePath}/v1/StaffLinking`;  
var clientdomain = `${hostname}${basePath}/v1/ClientLinking`; 
var workflowdomain = `${hostname}${basePath}/v1`; 
export const controlsheet = hostname + "/xcmv2/routing?tid=";

//var domain = "http://localhost:5102/api/v1/user";
//var staffdomain = "http://localhost:5102/api/v1/StaffLinking"
//var clientdomain = "http://localhost:5102/api/v1/ClientLinking"
//var workflowdomain = "http://localhost:5101/api/v1"
//export const controlsheet = "http://localhost:1259/xcmv2/routing?tid="



export default {
    getUsers: domain,
    getLookup: `${domain}/GetDefaultLookUpData`,
    updateUsersInGrid: `${domain}/gridupdate`,
    bulkUpdate: `${domain}/bulkupdate`,
    enableDisableUsers: `${domain}/userdisable`,
    createUser: `${domain}/Createuser`,
    updateUser: `${domain}/update`,
    getIndividualUserDetails: `${domain}/GetIndividualUserDetails`,
    notifyPasswordChange: `${domain}/NotifyPasswordChange`,
    resendResetPasswordChange: `${domain}/ResendResetPasswordChange`,
    getStaffReportDetails: `${staffdomain}/GetStaffLinkedData`,
    getStafflookUpDetails: `${staffdomain}/GetStaffLinkingLookUpData`,
    updateStaffIntegratedDetails: `${staffdomain}/UpdateGracePeriod`,
    getfirmlookUpDetails: `${domain}/GetFirmDetailsForBulkEdit`,
    getfirmGracePeriodDetails: `${staffdomain}/GetGracePeriod`,
    getMappeClientDetails: `${clientdomain}/GetMappedClientData`,
    getClientLookUpDetails: `${clientdomain}/GetClientLinkedData`,
    getIntegrationPhDetails: `${staffdomain}/GetStaffIntegrationPhDetails`,
    getTaxNotLinkedData: `${workflowdomain}/TaskEFile/GetTaxTasksToBeLinked`,
    getFirmDocumentSync: `${clientdomain}/GetFirmDocumentSync`,
    getWorkstreamLicenseDetails: `${staffdomain}/GetWorkstreamLicenceDet`,
};
